import React, {useContext} from 'react'

import { keyContext } from '../KeyContext'
import PulseLoader  from 'react-spinners/PulseLoader';

function WaitingModal({ shown, children}) { 

 const windowHeight = window.innerHeight
 const {leftMargin, apiLoader } = useContext(keyContext)
   //   if (!shown) return null;
 const override: CSSProperties = {
    display: "block",
    position: "absolute",
    top: "45%",
    left: "55%",
    margin: "0 auto",
    textAlign: "center",
    borderColor: "#982f2f",
    // transform: "translate(-50%, -50%)",
  };
// console.log(apiLoader, 'loader')
return shown ? (
 
    <div style={{position:'fixed',display:'flex',justifyContent:'center',top: windowHeight > 1000 ? '69px' : '0px',left:leftMargin,width:windowHeight > 1000 ? '1858px': '1920px',height:'94vh', backgroundColor:apiLoader  ? 'rgba(0,0,0,0.7)' : 'transparent',zIndex:100,overflowY:'auto', transition: 'background-color 1000ms linear'}}>
        {children} 
     
    <div style={{backgroundColor:apiLoader ? 'white' : 'none', width: '250px',height:'120px',padding:'20px',marginTop:'20px',borderRadius:'4px',position:'absolute',top:'45%',left:'50%',transform:'translate(-45%, -50%)',textAlign:'center'}}>
      {  apiLoader &&
      <div style={{display:'flex',marginTop:'20px'}}>
          <h2 style={{fontWeight:900,}}>Øjeblik </h2>  
          <PulseLoader color="#982f2f" loading={true} height={100} cssOverride={override}/>
      </div>
     }
     
     
    </div>
     </div>

    ) : null
}

export default WaitingModal